import {FC, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {get} from 'lodash'
import {ProcedureCategoryTab, ProcedureCategoryTabs} from 'features/procedures/ProcedureCategoryTabs'
import {procedureCategories, procedureTypes} from 'features/procedures/procedureTypes'
import {StartProcedureCard, Container} from 'features/procedures/StartProcedureCard'
import {isOfficeAdminSelector} from 'libs/redux'
import {useSelector} from 'hooks/redux'
import styles from './ProcedureNew.scss'

export const ProcedureNew: FC = () => {
  const location = useLocation()
  const currentUser = useSelector((state) => state.session.currentUser)
  const isOfficeAdmin = useSelector(isOfficeAdminSelector)

  const availableProcedureTypes = useMemo(
    () =>
      procedureTypes.filter(
        (pt) =>
          get(currentUser, `client_role.client_role_permissions.${pt.procedureType}.creatable`) && // use _.get because suppress type check error
          !(isOfficeAdmin && pt.procedureType === 'change_office') // FIXME: この条件はclient_role_permissionsで判定できるので不要という疑惑がある
      ),
    [currentUser, isOfficeAdmin]
  )

  const availableCategories = useMemo(() => {
    const categories = new Set(availableProcedureTypes.map((pt) => pt.category))
    return procedureCategories.filter((c) => categories.has(c.category))
  }, [availableProcedureTypes])

  const currentCategory = availableCategories.find((c) => c.category === location.hash.substring(1))
    ? location.hash.substring(1)
    : availableCategories[0]!.category
  const currentProcedureTypes = availableProcedureTypes.filter((pt) => pt.category === currentCategory)

  return (
    <>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">新規手続きを開始する</h1>
      </div>

      <ProcedureCategoryTabs>
        {availableCategories.map((category) => (
          <ProcedureCategoryTab
            key={category.category}
            category={category}
            active={category.category === currentCategory}
          />
        ))}
      </ProcedureCategoryTabs>

      <Container className={styles.container}>
        {currentProcedureTypes.map((procedureType) => (
          <StartProcedureCard
            key={procedureType.procedureType}
            to={`/${procedureType.procedureType}`}
            variant={procedureType.hasSubPage ? 'next' : 'start'}
          >
            {procedureType.title}
            <div className={styles.cardSubText}>{procedureType.description}</div>
          </StartProcedureCard>
        ))}
      </Container>
    </>
  )
}
